// This file is auto-generated.
// It's responsible for giving the view it's own Flow context.

import { Flow } from 'Simple/Flow'
import React from 'react'
import DataVaxiomRelationshipsItem from './view'

export default function DataVaxiomRelationshipsItemFlow({ children, ...props }) {
  return (
    <Flow viewPath={props.viewPath} flowDefinitionViewPathSource="/DesignSystem/DataVaxiomRelationshipsItem">
      <DataVaxiomRelationshipsItem {...props}>
        {children}
      </DataVaxiomRelationshipsItem>
    </Flow>
  )
}
